<!--
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-03-22 21:34:00
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-07-11 11:40:11
-->
<script setup lang="ts">
import { NConfigProvider, dateZhCN } from 'naive-ui'
import { NaiveProvider } from '@/components/common'
import { useTheme } from '@/hooks/useTheme'
import { useLanguage } from '@/hooks/useLanguage'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { useConfirm } from '@/hooks/useConfirm'
const { theme, themeOverrides } = useTheme()
const { language } = useLanguage()

const { confirmState, handleConfirm, handleCancel } = useConfirm()
</script>

<template>
  <NConfigProvider :theme="theme" :theme-overrides="themeOverrides" :locale="language" :date-locale="dateZhCN">
    <NaiveProvider>
      <RouterView />
      <CreateCompanyModal />
      <RiskWordAppealModal />
      <!-- <DrawIntelligent /> -->
      <!-- 智能问答助手 -->
      <AppAiQuotePopover />
    </NaiveProvider>
  </NConfigProvider>
  <!-- <DrawIntelligent /> -->
  <ConfirmDialog :is-visible="confirmState.isVisible" :options="confirmState.options" @confirm="handleConfirm"
    @cancel="handleCancel" />
</template>

<style>
.el-select-dropdown__item.selected {
  color: var(--color--primary) !important;
}
</style>
